import React, { CSSProperties } from 'react';
import LayoutRow from '../styling/LayoutRow';

interface IProps
{
	label: string,
	value: string | number | undefined,
	labelColumnClassName?: string,
	labelClassName?: string,
	labelStyle?: CSSProperties,
	valueColumnClassName?: string,
	valueClassName?: string,
	valueStyle?: CSSProperties
}

function BasicField(props: IProps)
{
	return (
		<LayoutRow className="basic-field-container">
			<div className={`col hide-overflow ${props.labelColumnClassName}`} >
				<span
					className={`${props.labelClassName} txt-dimmed-color no-padding no-margin`}
					style={props.labelStyle}>
					{props.label}
				</span>
			</div>
			<div className={`col hide-overflow  ${props.valueColumnClassName}`}>
				<span
					className={`${props.valueClassName} no-padding no-margin`}
					style={props.valueStyle}>
					{props.value ? props.value : '-'}
					{props.valueClassName === ' color-alert' ? <span>  &#9888;</span> : ''}
				</span>
			</div>
		</LayoutRow>
	);
};

export default BasicField;